import { render } from "./IconPhone.vue?vue&type=template&id=46fed972&scoped=true"
const script = {}

import "./IconPhone.vue?vue&type=style&index=0&id=46fed972&lang=scss&scoped=true"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fed972"]])

export default __exports__